import React from 'react';

const EventCardSkeleton = () => {
  return (
    <div className="w-full h-full bg-white overflow-hidden flex flex-col items-start drop-shadow-md relative animate-pulse opacity-50">
      {/* Header Banner Skeleton */}
      <div className="bg-gray-300 py-2 px-3 rounded-t-xl w-48">
        <div className="h-6 bg-gray-400 rounded w-32"></div>
      </div>

      <div className="w-full flex-1 rounded-tr-2xl rounded-b-2xl overflow-hidden shadow-lg flex flex-col">
        {/* Image Skeleton */}
        <div className="h-48 w-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-shimmer"></div>

        {/* Title Skeleton */}
        <div className="p-4 pb-2">
          <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
          <div className="h-6 bg-gray-300 rounded w-1/2"></div>
        </div>

        {/* Content Section */}
        <div className="p-4 pt-0 flex-1 flex flex-col bg-white">
          {/* Event Details Skeleton */}
          <div className="space-y-3 mb-6 flex-1">
            {/* Brief */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
            
            {/* Date */}
            <div className="flex items-center">
              <div className="w-5 h-5 bg-gray-300 rounded mr-2"></div>
              <div className="h-4 bg-gray-200 rounded w-32"></div>
            </div>

            {/* Time */}
            <div className="flex items-center">
              <div className="w-5 h-5 bg-gray-300 rounded mr-2"></div>
              <div className="h-4 bg-gray-200 rounded w-24"></div>
            </div>

            {/* Platform */}
            <div className="flex items-center">
              <div className="w-5 h-5 bg-gray-300 rounded mr-2"></div>
              <div className="h-4 bg-gray-200 rounded w-28"></div>
            </div>
          </div>

          {/* Action Buttons Skeleton */}
          <div className="flex gap-3 mt-auto">
            <div className="flex-1 h-12 bg-gray-300 rounded-lg"></div>
            <div className="flex-1 h-12 bg-gray-300 rounded-lg"></div>
          </div>
        </div>
      </div>

      {/* Shimmer Animation */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        .animate-shimmer {
          animation: shimmer 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default EventCardSkeleton;
